/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
const FlexAlertView = require('../../modules/views/flex_alert.js');
const FlightChangeFreeAlertView = require('../../modules/views/flight_change_free_alert');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');

module.exports = function() {
    'use strict';
    var trackingUtils = require('../utils/tracking.utils');
    var PriceSubscriberMixin = require('../mixins/price_subscriber.mixin');
    var common = require('../helpers/trip_summary_common');
    var baggagesRowsCollection = require('../collections/baggages_rows').getInstance();
    const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();
    var baggageOptionsCollection = require('../../modules/collections/baggages_row_options').getInstance();
    const boardingOptionsCollection = require('../../modules/collections/boarding_options/boarding_options.collection').getInstance({load: true});

    return Odigeo.View.extend(PriceSubscriberMixin.extend({
        templateSettings: Odigeo.Utils.getTmplSettings({variable: ''}),
        initialTop: 0,
        finalTop: 0,
        stickyEnabled: false,
        sidebarSegmentOrder: ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'FIFTH', 'SIXTH'],
        selectors: {
            totalPrice: '.total_price',
            showCcType: '.show_cc_type',
            showCcName: '.show_cc_name',
            stopsCounterList: '.stops',
            paxCounterList: '.pax',
            paxNameList: '.pax_name_list',
            seatmapTable: '.seatmap_table',
            wrapper: '.TSwrapper_summary',
            sidebarSummarySticky: '.sidebar_summary_sticky',
            priceSummary: '.TSprice_summary',
            titleSummary: '.TStitle_summary',
            paxSummary: '.TSpax_summary',
            flightSummary: '.TSflight_summary',
            accommodationSummary: '.TSaccommodation_summary',
            removeHotel: '.remove_hotel',
            paxCounterResult: '.pax_counter_result',
            paxCounterWrapper: '.pax_counter_wrapper',
            datailsButton: '.details_button',
            resultPriceBreakdown: '.result_price_breakdown',
            detailsPricebreakdown: '.details_pricebreakdown',
            tripDisclosure: '.trip_disclosure',
            exceptions: '.exceptions',
            exceptionsWrapper: '.exceptions_wrapper',
            tripBaggageRepricing: '.trip_baggage_repricing',
            owcSpecialRules: '.owc_special_rules',
            priceperpax: '.pax_price',
            cheapestPaymentmethodDisclaimer: '.cheapest_paymentmethod_disclaimer',
            sidebarSummaryPartialPriceLabel: '.sidebarSummary_partial_price_label',
            sidebarSummaryTotalPriceLabel: '.sidebarSummary_total_price_label',
            promocodeContainer: '.promocode_table',
            baggagesTemplate: '.baggage_template',
            baggagesTemplateSplitted: '.baggage_template_splitted',
            baggagesContainer: '.baggage_table',
            baggagesDisclaimer: '.baggage_disclaimer',
            passengersSection: '.passengers_sidebar',
            premiumPassengerSection: '.premium_passenger_sidebar',
            premiumPassengerName: '.premium_passenger_name_sidebar',
            membershipPriceDisplayCcFee: '.paymentfee.membership_price_display_cc_fee',
            membershipPriceDisplayFeeText: '.membership_price_display_fee_text',
            membershipPriceDisplayFeeValue: '.membership_price_display_fee_value',
            membershipPriceDisplayDisclaimer: '.membership_price_display_disclaimer',
            membershipPriceDisplayDisclaimerNoBtwnTrav: '.membership_price_display_disclaimer_no_btwn_trav',
            membershipPriceDisplayDisclaimerTxt: '.disclaimer_txt',
            SHPrice: '.SH_price',
            addpaxAction: '.details_change_pax_button',
            baggageSegmentTemplate: '.baggage_segment_tmpl',
            premiumBubbleContent: '.bubble_sidebar_member_content',
            premiumBubbleTemplate: '.bubble_sidebar_member_tmpl',
            priorityBoardingContainer: '.priority_boarding_container',
            flexAlertWrapper: '.flex_alert',
            flexAlertTemplate: '.flex_alert_template',
            flexAlertMessage: '.flex_message',
            flightChangeFreeAlertWrapper: '.fight_change_free_alert',
            flightChangeFreeTemplate: '.flight_change_free_alert_template',
            flightChangeFreeAlertMessage: '.flights_change_free_message',
            handBaggageTemplate: '.hand_baggage_template',
            priceContainer: '.sidebar_price_container',
            priceLoader: '.sidebar_price_loader',
            primePersuasionMessage: '.prime_persuasion_message',
            persuasiveMessageShow: '.persuasive_messages_show',
            gdsFreeCancellationMessage: '.od-persuasion-message-pax-summary-free-cancellation-hint',
            membershipFlexibilityLabel: '.membership_flexibility_sidebar',
        },
        events: {
            'tap .details_button': 'onDetailsButtonClick',
            'tap .change_search': 'changeResults',
            'tap .remove_hotel': 'removeHotel',
            'tap .accommodation_toggle_details': 'accommodationToggleDetails',
            'tap .change_suggestion': 'sendUserToResults',
            'tap @addpaxAction': 'onAddpaxAction',
            'tap .open_membership_lightbox_perks': 'onOpenMembershipLightboxPerks',
            'tap .collapsible_launch_popup_metaanc': 'openFlightDetailsSidebar',
        },

        openFlightDetailsSidebar: function() {
            Odigeo.trigger(this.widget.id + ':launchPopupSidebar');
        },
        setCcSelected: function(ccName) {
            this.$cachedSelectors.showCcName.html(ccName);
        },
        initializeStickyPrice: function() {
            this.stickyEnabled = this.isPayment() && this.$cachedSelectors.wrapper.data('sticky');
        },
        isPayment: function() {
            return this.model.get('page') === 'payment';
        },
        stickPriceSection: function(event) {
            if (!this.stickyEnabled) {
                return;
            }

            var marginBottom = 40;
            var scrollTop = event.scrollTop;
            var footerTop = event.footerTop;
            var headerHeight;
            var stickFooter;
            var stickIt;

            if (this.initialTop === 0) {
                this.initialTop = this.$cachedSelectors.priceSummary.offset().top;
            }

            stickIt = scrollTop > this.initialTop;

            this.$cachedSelectors.sidebarSummarySticky.toggleClass('sticky', stickIt);
            this.$cachedSelectors.titleSummary.toggleClass('odf-hidden', stickIt);
            this.$cachedSelectors.paxSummary.toggleClass('odf-hidden', stickIt);
            this.$cachedSelectors.flightSummary.toggleClass('odf-hidden', stickIt);
            this.$cachedSelectors.accommodationSummary.toggleClass('odf-hidden', stickIt);
            this.$cachedSelectors.exceptionsWrapper.toggleClass('odf-hidden', stickIt);

            if (stickIt) {
                headerHeight = $('#header').height();

                this.finalTop = footerTop -
                    this.$cachedSelectors.sidebarSummarySticky.height() -
                    headerHeight - marginBottom;

                stickFooter = scrollTop - headerHeight > this.finalTop;

                this.$cachedSelectors.sidebarSummarySticky.toggleClass('sticky-footer', stickFooter);
                this.$cachedSelectors.sidebarSummarySticky.css({
                    top: stickFooter ? this.finalTop : '',
                });
            }
        },
        onDetailsButtonClick: function(event) {
            trackingUtils.trackEvent('trip_information', 'open_trip_details_sidebar');
            Odigeo.trigger(this.widget.id + ':openFlightDetails', event, false);
        },
        changeResults: function changeResults(ev) {
            var to = $(ev.target).data('to');
            trackingUtils.trackEventWithCategory(to, 'searcher_flights', 'open_change_search');
            if (to !== 'livebox') {
                Odigeo.Router.navigate('results');
            }
        },
        initializesStops: function() {
            Odigeo._.each(this.$cachedSelectors.stopsCounterList, function(stopItem) {
                $(stopItem).html(Odigeo.Utils.pluralizeAll($(stopItem).data('plural'), parseInt($(stopItem).data('stops'), 10)));
            });
        },
        setPaxCounters: function() {
            var paxResult = [];

            Odigeo._.each(this.$cachedSelectors.paxCounterList, function(pax) {
                var $pax = $(pax);
                var count = parseInt($pax.data('count'), 10);
                if (count > 0) {
                    paxResult.push(Odigeo.Utils.pluralizeAll($pax.data('plural'), count));
                }
            });

            this.$cachedSelectors.paxCounterResult.html(Odigeo._.compact(paxResult).join(', '));
        },
        onUpdateTravellersName: function() {
            var travellers = Odigeo._.compact(this.model.get('paxNameList')) || [];
            var isEmptyTravellers = Odigeo._.isEmpty(travellers);
            var travellersTemplate;

            this.$cachedSelectors.paxCounterWrapper.toggleClass('odf-hidden', !isEmptyTravellers);

            if (this.model.get('page') === 'payment' || this.model.get('page') === 'metaancillaries') {
                var template = Odigeo._.template(this.$el.find('.passengers_list_template').html(), Odigeo.Utils.getTmplSettings());
                travellersTemplate = template({travellers: travellers});
            } else {
                travellersTemplate = travellers.join(', ');
            }

            this.$cachedSelectors.paxNameList.html(travellersTemplate).toggleClass('odf-hidden', isEmptyTravellers);
            this.$cachedSelectors.premiumPassengerName.html(travellersTemplate).toggleClass('odf-hidden', isEmptyTravellers);
            this.displayPremiumView(Odigeo._.size(this.model.get('paxNameList')) === 1 && this.model.get('isSinglePremiumPassengerSelected'));
        },
        displayPremiumView: function(hasToDisplay) {
            this.$cachedSelectors.passengersSection.toggleClass('odf-hidden', hasToDisplay);
            this.$cachedSelectors.premiumPassengerSection.toggleClass('odf-hidden', !hasToDisplay);
        },
        displayPremiumDisclaimers: function(hasToDisplay, action) {
            var hideNoBtwnTravDsc = action === 'discount' || action === 'noDiscount' || hasToDisplay;
            this.$cachedSelectors.membershipPriceDisplayDisclaimerNoBtwnTrav.toggleClass('odf-hidden', hideNoBtwnTravDsc);
            this.$cachedSelectors.membershipPriceDisplayDisclaimer.toggleClass('odf-hidden', true);
        },
        updatePriceMemberDisplayPrices: function(action, isSubscriptionAdded) {
            common.updatePriceMemberDisplayPrices({
                action: action,
                isSubscriptionAdded: !!isSubscriptionAdded,
                options: this.widget.options,
                $cachedSelectors: this.$cachedSelectors,
                $widget: this.$widget,
            });
        },
        updatePriceMemberDisplay: function(action, isSubscriptionAdded) {
            var isLikeLoginAction = action === 'login' || isSubscriptionAdded || action === 'discount';
            this.displayPremiumDisclaimers(isLikeLoginAction, action);
        },
        onUpdateBaggages: function() {
            var options = Odigeo.Utils.parseOptions(this.widget.options);

            var baggage = this.getBaggage();
            var templateData = this.getBaggageTemplateData(baggage);

            if (Odigeo.AB.isItineraryBagPriceSplitDesktop) {
                if (Odigeo._.isFunction(this.baggagesTemplateSplitted)) {
                    this.$cachedSelectors.baggagesContainer.html(this.baggagesTemplateSplitted(templateData));
                }
            } else {
                if (Odigeo._.isFunction(this.baggagesTemplate)) {
                    this.$cachedSelectors.baggagesContainer.html(this.baggagesTemplate(baggage));
                }
            }

            this.$cachedSelectors.baggagesContainer.attr('data-all-price-baggage', this.widget.getBaggageSelectedTotalPrice());
            this.checkPricebreakDownVisibility();
            Odigeo.trigger('getTotalByFullprice', this.$widget);

            this.renderBaggageDisclaimer(options.translations);
        },
        getBaggage: function() {
            return Odigeo.AB.isItineraryBagPriceSplitDesktop
                ? this.widget.getAllBaggagePriceBreakDownItems()
                : this.widget.getBaggagePriceBreakDownItems();
        },
        getBaggageTemplateData: function(baggage) {
            var flightType = baggagesRowsCollection.getRequestType();

            return {
                baggageInfo: this.widget.extendItineraryBaggage(baggage),
                price: this.widget.getTotalPrice(baggage),
                translations: this.widget.options.translations.flightTypes[flightType],
            };
        },
        getNumberBaggagePieces: function() {
            return Odigeo.AB.isItineraryBagPriceSplitDesktop
                ? this.widget.calculateTotalQuantity()
                : this.widget.getBaggageSelectedPieces();
        },
        updatePromocode: function(promoCode) {
            common.updatePromocode({
                $cachedSelectors: this.$cachedSelectors,
                promoCode: promoCode,
                $widget: this.$widget,
            });
        },
        renderBaggageDisclaimer: function(translations) {
            var baggageFeeDisclaimer = this.$cachedSelectors.baggagesContainer.find('.baggage_fee_disclaimer');
            var numberPieces = this.getNumberBaggagePieces();
            var fee = this.widget.getSelectedBaggageAverageFee();

            baggageFeeDisclaimer.html(Odigeo.Utils.replaceCmsKeyArgs(translations.disclaimer.baggageFee, fee));
            baggageFeeDisclaimer.toggleClass('odf-hidden', numberPieces === 0 || fee === 0);
        },
        onUpdateSeatmap: function() {
            var seatMap = this.model.get('seatmap');
            var hasSelectedSeats = Odigeo._.gt(seatMap.quantity, 0);
            var selectedSeatsLength = Odigeo._.isEmpty(seatMap) ? 0 : seatMap.quantity;
            var selectedSeatsPrice = Odigeo._.isEmpty(seatMap) ? 0 : seatMap.allprice;
            var $seatmapTable = this.$cachedSelectors.seatmapTable;
            var $seatMapConcept = $seatmapTable.find('.seat_map_concept');
            var seatMapConceptText = Odigeo.Utils.pluralizeAll($seatMapConcept.attr('data-plural'), selectedSeatsLength);
            var $seatMapAllPrice;

            if (hasSelectedSeats) {
                $seatmapTable.data('quantity-seatmap', selectedSeatsLength);
                $seatMapAllPrice = $seatmapTable.find('.seat_map_all_price');
                $seatMapAllPrice.html(Odigeo.Utils.formatCurrency(selectedSeatsPrice));
                $seatMapAllPrice.attr('data-allprice-seatmap', selectedSeatsPrice);
                $seatMapConcept.html(seatMapConceptText);
            }

            $seatmapTable.toggleClass('hidden', !hasSelectedSeats);
            this.checkPricebreakDownVisibility();
        },
        checkPricebreakDownVisibility: function() {
            var hasSeats = this.model.get('seatmap').quantity > 0;
            var hasBaggages = !this.widget.hasNoBagBeenSelected();

            if (this.$cachedSelectors.detailsPricebreakdown.length > 0) {
                this.$cachedSelectors.detailsPricebreakdown.toggleClass('odf-hidden', (!hasSeats && !hasBaggages));
            }
        },
        repaintPrices: function(finalPrice, pricePerPassenger, SHPrice) {
            this.$cachedSelectors.totalPrice.html(finalPrice);
            this.$cachedSelectors.priceperpax.html(pricePerPassenger);
            if (Odigeo.Membership.isMembershipProductEnabledDesktop && finalPrice) {
                Odigeo.trigger(`${this.widget.id}:getMembershipInfo`);
                this.model.set('finalPrice', finalPrice);
            }
            if (!Odigeo._.isUndefined(this.$cachedSelectors['SHPrice'])) {
                this.$cachedSelectors['SHPrice'].html(SHPrice);
            }
        },
        aggregateBaggagePrices: function() {
            var prices = {totalBaggagePrice: 0, totalBaggagePrimePrice: 0};
            const piecesBySegment = baggageOptionsCollection.getAllPiecesBySegment();
            Odigeo._.each(piecesBySegment, function(segment, _) {
                Odigeo._.each(segment, function(option, _) {
                    const price = option.get('price');
                    const primePrice = option.get('primePrice');
                    prices.totalBaggagePrice += price;
                    prices.totalBaggagePrimePrice += primePrice;
                });
            }, this);
            return prices;
        },
        calculatePrimeDiscount: function(prices) {
            const membershipDiscount = Odigeo.Membership.membershipDiscount;
            const {baggagePrice, baggagePrimePrice, handbagPrice, handbagPrimePrice} = prices;
            const baggagePrimeSavedAmount = baggagePrice - baggagePrimePrice;
            const handbagPrimeSavedAmount = handbagPrice - handbagPrimePrice;
            // The calculation was truncated to 2 decimals to fix a common JS float issue that adds undesired decimals
            return Math.floor(((membershipDiscount - (baggagePrimeSavedAmount + handbagPrimeSavedAmount)) * 100)) / 100;
        },
        updateSmoothPrice: function({page, price}) {
            if (page === 'details') {
                const fullFareElement = this.$el.find('#bubble_sidebar_full_fare');
                fullFareElement?.html(price);
            } else {
                const isMeta = Odigeo.SessionScope.isMeta;
                if (page === 'payment' && isMeta) {
                    const baggagePrices = this.aggregateBaggagePrices();
                    const handbagPrice = boardingOptionsCollection.getSelectionDapiPrice();
                    const handbagPrimePrice = boardingOptionsCollection.getSelectionDapiPrice('totalPrimePrice');
                    if ((baggagePrices.totalBaggagePrice > 0 && baggagePrices.totalBaggagePrimePrice > 0) ||
                        (handbagPrice > 0 && handbagPrimePrice > 0)) {
                        const aggregatedDiscount = this.calculatePrimeDiscount({
                            baggagePrice: baggagePrices.totalBaggagePrice,
                            baggagePrimePrice: baggagePrices.totalBaggagePrimePrice,
                            handbagPrice: handbagPrice,
                            handbagPrimePrice: handbagPrimePrice,
                        });
                        this.$el.find('.membership_discount_fee').html(Odigeo.Utils.formatCurrency(aggregatedDiscount));
                    }
                }
                const finalPrice = this.model.get('finalPrice');
                this.$el.find('#bubble_sidebar_full_fare')?.html(finalPrice);
                this.$el.find('#bubble_sidebar_prime_fare')?.html(finalPrice);
            }
        },
        showFinalPrice: function(showFinalPrice) {
            this.$cachedSelectors.sidebarSummaryPartialPriceLabel.toggleClass('odf-hidden', showFinalPrice);
            this.$cachedSelectors.sidebarSummaryTotalPriceLabel.toggleClass('odf-hidden', !showFinalPrice);
        },
        showPriceWithoutDiscountSelectedDisclaimer: function() {
            if (!Odigeo._.isEmpty(this.$cachedSelectors.cheapestPaymentmethodDisclaimer)) {
                var isPriceWithoutDiscountSelected = this.$cachedSelectors.cheapestPaymentmethodDisclaimer.data('isPriceWithoutDiscountSelected');
                this.$cachedSelectors.cheapestPaymentmethodDisclaimer.toggleClass('odf-hidden', isPriceWithoutDiscountSelected);
            }
        },
        renderPremiumBubble: function(membershipSettings) {
            const premiumBubble = common.renderPremiumBubble({
                membershipSettings: membershipSettings,
                $cachedSelectors: this.$cachedSelectors,
                options: this.widget.options,
                templateSettings: this.templateSettings,
            });
            if (Odigeo.Membership.isMembershipProductEnabledDesktop) {
                var isPaymentPage = this.model.get('page') === 'payment';
                this.showFinalPrice(isPaymentPage || membershipSettings.isSubscriptionAdded || !membershipSettings.isCheapestPriceSelected);
            }
            return premiumBubble;
        },
        getMembershipTrackingLabel: function(e) {
            var status = $(e.currentTarget).data('status');
            var labelTracking = {
                'logged-applied': 'member',
                'member-not-travelers': 'member_missing',
                'applied': 'prime_suggested',
                'not-applied': 'not_elegible',
                'subscription-added': 'prime_added',
            };
            return labelTracking[status];
        },
        renderFlexAlert: function() {
            insuranceCatalogueCollection.getLoadedPromise().then((loaded) => {
                if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
                    if (!Odigeo.Session.get('FlexSystemAlertClosed')) {
                        new FlexAlertView({
                            el: this.$cachedSelectors.flexAlertWrapper,
                            template: Odigeo._.template(this.$cachedSelectors.flexAlertTemplate.html(), Odigeo.Utils.getTmplSettings()),
                            translations: this.widget.options.translations.flexibilityDisruption,
                            page: 'pax',
                        });
                        this.$el.find(this.$cachedSelectors.flexAlertWrapper).removeClass('odf-hidden');
                    }
                    this.$el.find(this.$cachedSelectors.flexAlertMessage).removeClass('odf-hidden');
                }
            });
        },
        renderFlightChangeAlertWhenAvailable() {
            if (flightChangeFreeUtil.isSelectedFlightChangeableForFree()) {
                this.renderFlightChangeAlert();
            }
        },
        renderFlightChangeAlert() {
            this.$el.find(this.$cachedSelectors.flightChangeFreeAlertMessage).removeClass('odf-hidden');
            this.$el.find(this.$cachedSelectors.persuasiveMessageShow).addClass('odf-hidden');
            const isPaymentPage = Odigeo._.get(this.widget.options, 'page') === 'payment';
            if (!Odigeo.Session.get('FlightChangeFreeSystemAlertClosed') && !isPaymentPage) {
                new FlightChangeFreeAlertView({
                    el: this.$cachedSelectors.flightChangeFreeAlertWrapper,
                    template: Odigeo._.template(this.$cachedSelectors.flightChangeFreeTemplate.html(), Odigeo.Utils.getTmplSettings()),
                    translations: this.widget.options.translations.flightChangeFree,
                    page: 'pax',
                });
                this.$el.find(this.$cachedSelectors.flightChangeFreeAlertWrapper).removeClass('odf-hidden');
            }
        },
        renderFlexibility() {
            this.$el.find(this.$cachedSelectors.membershipFlexibilityLabel).removeClass('odf-hidden');
        },
        onOpenMembershipLightboxPerks: function(e) {
            trackingUtils.trackEvent('sidebar_prime', 'click_logo_' + this.getMembershipTrackingLabel(e));
        },
        toggleCcType: function(show) {
            this.$cachedSelectors.showCcType.toggleClass('odf-hidden', !show);
        },
        onAddpaxAction: function(e) {
            Odigeo.trigger(this.widget.id + ':addPaxSidebar', e);
        },
        updatePricesWithMembershipSubscription: function(membershipPriceItem) {
            var membershipSubscriptionTable = this.$el.find('.membership_subscription_table');
            var shouldBeHidden = membershipPriceItem.allPrice === 0;

            membershipSubscriptionTable.toggleClass('odf-hidden', shouldBeHidden);
            membershipSubscriptionTable.find('.od-js-all-price').attr('data-all-price', membershipPriceItem.allPrice);
            membershipSubscriptionTable.find('.od-js-one-price').html(Odigeo.Utils.formatCurrency(membershipPriceItem.onePrice));
            membershipSubscriptionTable.find('.od-js-quantity').html(membershipPriceItem.quantity);
            membershipSubscriptionTable.find('.od-js-all-price').html(Odigeo.Utils.formatCurrency(membershipPriceItem.allPrice));
        },
        confirmHotelRemoved: function() {
            this.$cachedSelectors.sidebarSummarySticky.addClass('hotel_removed');
        },
        accommodationToggleDetails: function(ev) {
            var $currentTarget = $(ev.currentTarget);
            var optionsDetails = Odigeo._.clone($currentTarget.data('details'));
            var label = $currentTarget.data('label');
            var target = Odigeo.History.getPageNameFromFragment() + '_flights_container';
            var isOpen = this.$('#' + target).hasClass('open');

            ev.stopPropagation();
            optionsDetails.target = target;
            Odigeo.trigger(this.widget.id + ':toggleDetails', optionsDetails);

            if (!isOpen && label) {
                trackingUtils.trackEvent('trip_information', label);
            }
        },
        removeHotel: function() {
            var imgUrl = this.$el.find('.xsell_hotel_image').attr('src');
            if (!this.$cachedSelectors.removeHotel.data('disabled')) {
                Odigeo.trigger(this.widget.id + ':removeHotel', imgUrl);
            }
        },
        disableRemoveHotel: function() {
            this.$cachedSelectors.removeHotel.data('disabled', true);
        },
        enableRemoveHotel: function() {
            this.$cachedSelectors.removeHotel.data('disabled', false);
        },
        sendUserToResults: function(ev) {
            var isIntermediatePage = $(ev.target).data('isUpsell');

            if (isIntermediatePage) {
                Odigeo.Router.navigate('results');
            } else {
                this.sendUserToDpResults(ev);
            }
        },
        sendUserToDpResults: function(ev) {
            Odigeo.Session.remove('before-page');
            Odigeo.trigger(this.widget.id + ':sendUserToDpResults', $(ev.target).data('product'));
        },

        init: function() {
            this.initializesStops();
            this.setPaxCounters();

            if (this.$cachedSelectors.baggageSegmentTemplate.html()) {
                this.baggageSegmentTemplate = Odigeo._.template(this.$cachedSelectors.baggageSegmentTemplate.html(), this.templateSettings);
            }

            if (this.$cachedSelectors.handBaggageTemplate.html()) {
                this.handBaggageTemplate = Odigeo._.template(this.$cachedSelectors.handBaggageTemplate.html(), this.templateSettings);
            }

            if (this.widget.options.page === 'details') {
                var bagTemplateSettings = Odigeo._.extend({}, this.templateSettings, {variable: 'priceDescriptorsArray'});
                this.baggagesTemplate = Odigeo._.template(this.$cachedSelectors.baggagesTemplate.html(), bagTemplateSettings);
                this.baggagesTemplateSplitted = Odigeo._.template(this.$cachedSelectors.baggagesTemplateSplitted.html(), bagTemplateSettings);
            }

            if (!Odigeo._.isEmpty(this.$cachedSelectors.resultPriceBreakdown)) {
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.resultPriceBreakdown, {
                    events: {
                        tap: true,
                    },
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            page: Odigeo.History.getPageNameFromFragment(),
                            action: 'trip_information',
                            label: 'open_price_breakdown',
                        },
                    },
                });
            }
            if (!Odigeo._.isEmpty(this.$cachedSelectors.tripDisclosure)) {
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.tripDisclosure, {
                    events: {
                        tap: true,
                    },
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            page: Odigeo.History.getPageNameFromFragment(),
                            action: 'trip_information',
                            label: 'open_notes_tooltip',
                        },
                    },
                });
            }
            if (this.$cachedSelectors.tripBaggageRepricing.length) {
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.tripBaggageRepricing, {
                    events: {
                        tap: true,
                    },
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            'category': 'flights_pay_page',
                            'action': 'trip_information',
                            'label': 'baggage_allowance_changed_details_clicks',
                        },
                    },
                });
                trackingUtils.trackEvent('trip_information', 'baggage_allowance_changed');
            }

            if (this.$cachedSelectors.owcSpecialRules.length) {
                trackingUtils.trackEvent('on_load', 'xfaring_info_loaded');
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.owcSpecialRules, {
                    events: {
                        tap: true,
                    },
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            action: 'xfaring_info',
                            label: 'xfaring_info_clicked',
                        },
                    },
                });
            }

            this.listenTo(this.model, 'change:seatmap', this.onUpdateSeatmap);
            this.listenTo(this.model, 'change:paxNameList', this.onUpdateTravellersName);
            this.listenTo(this.model, 'updatePrices', this.repaintPrices);

            this.processCancellationFree();
        },

        processCancellationFree: function() {
            insuranceCatalogueCollection.getLoadedPromise().then((loaded) => {
                if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
                    this.$cachedSelectors.gdsFreeCancellationMessage.addClass('odf-hidden');
                }
            });
        },

        togglePriceLoading: function(val) {
            this.$el.find(this.$cachedSelectors.priceContainer).toggleClass('od-smooth-opacity-layer', val);
            this.$el.find(this.$cachedSelectors.priceLoader).toggleClass('odf-hidden', !val);
        },
    }));
}();
